
// NEW PLANS FEATURES
export const newPlans = [
  {
    id: 1,
    name: "free",
    description:
      "For individuals and businesses initiating their social media adventure.",
    // note: "All free plan features plus",
    features: [
      "Management of 1 brand",
      "1 user",
      "3 Channels (FB, IG, and LinkedIn)",
      "5 created posts per channel per month",
      "20 AI Credits (one-time)",
      "Basic planning and publishing features",
      "IG Grid",
      "Integrations",
      "Post to Story",
    ],
  },
  {
    id: 2,
    name: "essential",
    description:
      "For experts employing publishing, analysis & interaction instruments.",
    note: "Free plan benefits plus",
    features: [
      "Management of 1 brand",
      "1 user",
      "6 Channels (FB, IG, X, LinkedIn, YouTube, and TikTok)",
      "80 created posts per month",
      "30 AI credits (monthly)",
      "Twitter Threads",
      "Analytics",
      "DMs",
      "Comments",
    ],
  },
  {
    id: 3,
    name: "growth",
    description:
      "For groups seeking more members, teamwork, and collaboration.",
    note: "Essential plan benefits plus",
    features: [
      "Management of 1 brand",
      "2 users",
      "6 Channels (FB, IG, X, LinkedIn, YouTube, and TikTok)",
      "200 created posts per month",
      "80 AI credits (monthly)",
      "Draft collaboration tools",
      "Post Queueing"
    ],
  },
  {
    id: 4,
    name: "agency",
    description: "For marketing companies managing 5+ brand customers.",
    note: "Growth plan benefits plus",
    features: [
      "Management of 5 brands",
      "5 users",
      "24 Channels (FB, IG, X, LinkedIn, YouTube, and TikTok each)",
      "Unlimited posts per month",
      "200 AI credits (monthly)",
      "Priority customer support",
    ],
  },
];
